module.exports = __webpack_public_path__ + "static/media/flyer.8126dfcd.svg";